/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-06-12 13:39:37
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbGoodsSpecs {
    /**
     * 查询商品规格列表
     */
    export var GetTbGoodsSpecsList = (): Promise<any> => {
        return Get(`/api/TbGoodsSpecs/GetTbGoodsSpecsList`, {});
    };
    /**
     * 新增商品规格
     */
    export var PostTbGoodsSpecs = (body:any): Promise<any> => {
        return Post(`/api/TbGoodsSpecs/PostTbGoodsSpecs`, body);
    };
    /**
     * 修改商品规格
     */
    export var PutTbGoodsSpecs = (body:any): Promise<any> => {
        return Put(`/api/TbGoodsSpecs/PutTbGoodsSpecs`, body);
    };
    /**
     * 删除商品规格
     */
    export var DeleteTbGoodsSpecs = (id:any): Promise<any> => {
        return Delete(`/api/TbGoodsSpecs/DeleteTbGoodsSpecs?id=${id}`, {});
    };
   
    
   
  
    
}



// WEBPACK FOOTER //
// ./src/http/api_TbGoodsSpecs.ts